/**
 * 403 — нет доступа к ресурсу.
 * Auth есть, но прав не хватает (например, чужая компания / архивный объект).
 */
import { ErrorLayout, ErrorBlock } from '@/components/layout/ErrorLayout'
import { Button } from '@/components/ui/Button'

export function Forbidden() {
  return (
    <ErrorLayout>
      <ErrorBlock
        icon="shield-x"
        iconTone="warning"
        title="Доступ закрыт 🔒"
        body={
          <p>
            У тебя нет прав на эту страницу. Если думаешь, что это ошибка — напиши владельцу компании или в поддержку.
          </p>
        }
        actions={
          <>
            <Button asChild variant="primary"><a href="/">На главную</a></Button>
            <Button asChild variant="ghost"><a href="mailto:support@agentceo.ru">support@agentceo.ru</a></Button>
          </>
        }
      />
    </ErrorLayout>
  )
}
